/**
 * Both external and internal routes.
 *  - Application has been setup as a SPA, app is used for initial single page load.
 */
const EXTERNAL_ROUTES = {
  appleAppDownload: "https://apps.apple.com/nz/app/ovrcome/id1545526126",
  googlePlayAppDownload:
    "https://play.google.com/store/apps/details?id=io.ovrcome&hl=en&gl=US",
  termsAndConditions: "https://www.ovrcome.io/terms-and-conditions",
  privacyPolicy: "https://www.ovrcome.io/privacy-policy",
  deviceSearch: "https://www.ovrcome.io/device-compatibility",
};

const ROUTES = {
  // SPA
  app: "*",

  // Style guide
  styleGuide: "/style-guide",
};

export { EXTERNAL_ROUTES, ROUTES };
